import { FieldSchema } from "../../../Schema";
import { isSecondaryIdField, LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { Modes } from "../../common/fields/mode";
import { readStoredText, writeStoredText } from "../../common/fields/stored";

export const equipmentId: FieldSchema = {
  grid: {
    displayed: true,
    order: 7,
    filterBlank: true,
    sortable: false,
  },
  name: "equipmentId",
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ equipmentId }) => readStoredText(equipmentId) },
    fromDb: { getter: ({ equipmentId }) => readStoredText(equipmentId) },
    // Back out as the placeholder: this column is one an index is keyed on, or
    // one the resolvers keep a placeholder in for a consumer's index.
    toDb: { getter: ({ equipmentId }) => writeStoredText(equipmentId) },
  },
  display: {
    displayed: true,
  },
  validation: {
    // The linked instance's own `secondaryIdMapping` decides this. The "anything but None"
    // test below it is what the rule said before the mapping was read here, and it stands in
    // only for an instance whose mapping is missing: the CSV import applied the mapping while
    // the form applied the heuristic, so the two disagreed for any instance identified by
    // something other than an equipment ID.
    required: {
      getter: ({ linkedInstance }) =>
        isSecondaryIdField(linkedInstance, "equipmentId") ??
        (!!linkedInstance && (linkedInstance as LinkedInstance)?.linkedInstance !== "None"),
      fields: ["linkedInstance"],
    },
  },
  form: {
    label: "Equipment ID",
    disabled: {
      getter: ({ linkedInstance, mode }) => {
        const linkedInstanceValue = (linkedInstance as LinkedInstance)?.linkedInstance;
        return [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          !["None"].includes(linkedInstanceValue);
      },
      fields: ["linkedInstance", "mode"],
    },
  },
};
